import * as types from '../types/facility';

const initialState = {
  isRegistering: false,
  apn_ref_no: null,
  apn_fee: 0.0,
  apn_id:0,
  registerError: null,

  applications: null,
  isFetchingApplications: false,
  fetchingApplicationsError: null
}

export default function facilityRegister(state = initialState, action) {
  switch (action.type) {
    case types.REGISTER_FACILITY_APPLICATION_REQ:
      return {
        ...state,
        isRegistering: true,
        apn_ref_no: null,
        apn_fee: 0.0,
        apn_id: 0,
        registerError: null,
      };
    case types.REGISTER_FACILITY_APPLICATION_RES:
      return {
        ...state,
        apn_ref_no: action.data.apn_ref_no,
        apn_fee: action.data.apn_fee,
        apn_id: action.data.apn_id,

        isRegistering: false,
        registerError: null,
      };
    case types.REGISTER_FACILITY_APPLICATION_ERR:
      return {
        ...state,
        registerError: action.error,
        apn_ref_no: null,
        isRegistering: false
      };
    case types.FETCH_FACILITY_APPLICATION_REQ:
      return {
        ...state,
        applications: null,
        isFetchingApplications: true,
        fetchingApplicationsError: null
      };
    case types.FETCH_FACILITY_APPLICATION_RES:
      return {
        ...state,
        applications: action.data,
        isFetchingApplications: false,
        fetchingApplicationsError: null
      };
    case types.FETCH_FACILITY_APPLICATION_ERR:
      return {
        ...state,
        applications: [],
        isFetchingApplications: false,
        fetchingApplicationsError: action.error,
      };
    default:
      return state;
  }
}